import { createAction, props } from '@ngrx/store';
import { IGetDirectorsPreviousResponse } from '../models/get-directors.model';

export const loadPreviousDirectorsAndAdmins = createAction(
  '[PreviousDirectorsAndAdmins] Load PreviousDirectorsAndAdmins',
  props<{
    request: { businessId: string; userRoleIds: string[] };
  }>()
);

export const loadPreviousDirectorsAndAdminssSuccess = createAction(
  '[PreviousDirectorsAndAdmins] Load PreviousDirectorsAndAdmins Success',
  props<{ response: IGetDirectorsPreviousResponse[] }>()
);

export const loadPreviousDirectorsAndAdminssFailure = createAction(
  '[PreviousDirectorsAndAdmins] Load PreviousDirectorsAndAdminss Failure',
  props<{ error: Error | any }>()
);
